import { render, staticRenderFns } from "./ImgLibrary.vue?vue&type=template&id=48fc5823&"
import script from "./ImgLibrary.vue?vue&type=script&lang=js&"
export * from "./ImgLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48fc5823')) {
      api.createRecord('48fc5823', component.options)
    } else {
      api.reload('48fc5823', component.options)
    }
    module.hot.accept("./ImgLibrary.vue?vue&type=template&id=48fc5823&", function () {
      api.rerender('48fc5823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/imgLibrary/ImgLibrary.vue"
export default component.exports